import Icon from "@core-components/icon/Icon";
import InfoCardGrid from "@core-components/info-card/InfoCardGrid";
import useAppTranslation from "@hooks/language/useAppTranslation";

export const SkinFeatures = () => {
  const { t: tCommon } = useAppTranslation("common");

  return (
    <InfoCardGrid
      cards={[
        {
          withBackground: false,
          icon: <Icon.Tick size={50} />,
          title: tCommon("infoCards.smurfRankedReady.title"),
          text: tCommon("infoCards.smurfRankedReady.text"),
        },
        {
          withBackground: false,
          icon: <Icon.TrophyStarred size={50} />,
          title: tCommon("infoCards.unrankedMmr.title"),
          text: tCommon("infoCards.unrankedMmr.text"),
        },
        {
          withBackground: false,
          icon: <Icon.OpenLockNoLock size={50} />,
          title: tCommon("infoCards.fullAccess.title"),
          text: tCommon("infoCards.fullAccess.text"),
        },
      ]}
    />
  );
};
